import React, { ReactNode } from "react";
import { Badge } from "./ui/badge";
// import { Badge } from '@/components/ui/badge';

// 1. Definisikan tipe data untuk props Timeline
interface TimelineProps {
  children: ReactNode;
  containerClass?: string;
}

export const Timeline: React.FC<TimelineProps> = ({
  children,
  containerClass = "",
}) => {
  return (
    <div
      className={`relative pl-4 border-l-2 space-y-6 my-2 ${containerClass}`}
    >
      {children}
    </div>
  );
};

// 2. Definisikan tipe data untuk props TimelineItem
interface TimelineItemProps {
  title: string | ReactNode;
  value: string | ReactNode;
  isActive?: boolean;
  activeColorClass?: string;
  badgeText?: string;
}

export const TimelineItem: React.FC<TimelineItemProps> = ({
  title,
  value,
  isActive = false,
  activeColorClass = "",
  badgeText,
}) => {
  return (
    <div className="relative">
      {/* Ubah -left-[21px] menjadi -left-[23px] di baris ini */}
      <span
        className={`absolute -left-[23px] top-1 w-3 h-3 rounded-full ring-4 ring-white dark:ring-slate-900 ${
          isActive ? activeColorClass : "bg-gray-400 dark:bg-slate-600"
        }`}
      />
      <p className="text-sm font-medium text-slate-500 dark:text-slate-400 mb-0.5">
        {title}
      </p>
      <p className="text-base font-bold text-slate-900 dark:text-white">
        {value}
      </p>

      {badgeText && (
        <Badge variant="secondary" className="mt-2">
          {badgeText}
        </Badge>
      )}
    </div>
  );
};
